<script>
    export default {
        props: {
            filter: {
                type: Object,
                default() {
                    return {}
                },
            },
            label: {
                type: String,
                default: '',
            },
        },
    }
</script>

<template>
    <bg-table view="details?for=Reference&amp;id=${Id}"
              create="create?for=Reference"
              :remove="{ id: 'Id', translation: 'ReferenceI18ns', name: 'Name', desc: $t('Reference') }"
              :label="label"
              path="reference"
              object="Reference"
              :filter="filter"
              v-slot="data"
              :state-view="true">
        <bg-column :label="$t('Name')" sort="Name">{{ data.row.ReferenceI18ns[0].Name }}</bg-column>
        <bg-column-files-count :label="$t('Files')" :count="Object.keys(data.row.Reference2Files).length"/>
        <bg-column-files-count :label="$t('Sub-brands')" :count="Object.keys(data.row.Reference2Groups).length"/>
        <bg-column-files-count :label="$t('Products')" :count="Object.keys(data.row.Reference2Products).length"/>
        <bg-column-files-count :label="$t('Systems')" :count="Object.keys(data.row.Reference2Systems).length"/>
        <bg-column-files-count :label="$t('Components')" :count="Object.keys(data.row.Reference2Components).length"/>
    </bg-table>
</template>
